var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterMobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9927C32 7.15612 24.8366 -0.00732422 16 -0.00732422C7.16344 -0.00732422 0 7.15612 0 15.9927C0 24.8292 7.16344 31.9927 16 31.9927C24.8366 31.9927 32 24.8292 32 15.9927Z",
    fill: "#001D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2439 6.24268H25.5532L18.3251 14.5021L26.8282 25.7427H20.172L14.9548 18.9271L8.99229 25.7427H5.67822L13.4079 16.9068L5.25635 6.24268H12.0813L16.7923 12.4724L22.2439 6.24268ZM21.0813 23.7646H22.9142L11.0829 8.11768H9.11416L21.0813 23.7646Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterMobIcon);
export default __webpack_public_path__ + "static/media/twitter_mob_icon.367af1b78652eb83317332cd01b45c92.svg";
export { ForwardRef as ReactComponent };